import SAJM_GLOBALS from "../constants";
import GlobalUser from "../models/User";

export class SubscriptionController{


    /*GET ALL CATEGORIES */
    async getCategories() {

        let apiKey = GlobalUser.getApiKey();
        let token = GlobalUser.getToken();

        try {
            
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({  apiFunctionName: "getCategories",
                                        apiKey: apiKey,
                                        apiToken: token,
                                    })
            };

            let url = SAJM_GLOBALS.API_HOST+"/";
            const response = await fetch(url, requestOptions);
                        
            if (!response.ok) {
                throw Error(response.statusText);
            }

            return await response.json();

        }
        catch (error) {
            console.log("SubscriptionController.getCategories:"+error);
        }
    }

    /* COUNT CONTACTS By CATEGORY*/
    async getCountContactsByCategory(){
        let apiKey = GlobalUser.getApiKey();
        let token = GlobalUser.getToken();

        try {
            
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({  apiFunctionName: "countContactsByCategory",
                                        apiKey: apiKey,
                                        apiToken: token,
                                    })
            };

            let url = SAJM_GLOBALS.API_HOST+"/";
            const response = await fetch(url, requestOptions);
                        
            if (!response.ok) {
                throw Error(response.statusText);
            }

            return await response.json();

        }
        catch (error) {
            console.log("SubscriptionController.getCountContactsByCategory:"+error);
        }
    }



    /*AJOUTER UNE NOUVELLE CATEGORIE */
    async addCategory(category) {

        let apiKey = GlobalUser.getApiKey();
        let token = GlobalUser.getToken();

        try {
            
            const apiFunctionParams =  "{\"category\": \""+category+"\"}";

            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({  apiFunctionName: "createCategory",
                                        apiKey: apiKey,
                                        apiToken: token,
                                        apiFunctionParams: apiFunctionParams
                                    })
            };

            let url = SAJM_GLOBALS.API_HOST+"/";
            const response = await fetch(url, requestOptions);

                        
            if (!response.ok) {
                throw Error(response.statusText);
            }

            return await response.json();

        }
        catch (error) {
            console.log("SubscriptionController.addCategory:"+error);
        }
    }


    /*SUPPRIMER UNE CATEGORIE */
    async deleteCategory(id) {

        let apiKey = GlobalUser.getApiKey();
        let token = GlobalUser.getToken();

        try {
            
            const apiFunctionParams =  "{\"id\": \""+id+"\"}";

            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({  apiFunctionName: "deleteCategory",
                                        apiKey: apiKey,
                                        apiToken: token,
                                        apiFunctionParams: apiFunctionParams
                                    })
            };

            let url = SAJM_GLOBALS.API_HOST+"/";
            const response = await fetch(url, requestOptions);

                        
            if (!response.ok) {
                throw Error(response.statusText);
            }

            return await response.json();

        }
        catch (error) {
            console.log("SubscriptionController.deleteCategory:"+error);
        }
    }


    /*METTRE A JOUR UNE CATEGORIE */
    async updateCategory(id, category) {

        let apiKey = GlobalUser.getApiKey();
        let token = GlobalUser.getToken();

        try {
            
            const apiFunctionParams =  "{\"id\": \""+id+"\", " +
                                        "\"category\": \""+category+"\"}";

            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({  apiFunctionName: "updateCategory",
                                        apiKey: apiKey,
                                        apiToken: token,
                                        apiFunctionParams: apiFunctionParams
                                    })
            };

            let url = SAJM_GLOBALS.API_HOST+"/";
            const response = await fetch(url, requestOptions);

                        
            if (!response.ok) {
                throw Error(response.statusText);
            }

            return await response.json();

        }
        catch (error) {
            console.log("SubscriptionController.updateCategory:"+error);
        }
    }


    /*Retourne les contacts ids d'une category */
    async getCategoryContacts(id) {

        let apiKey = GlobalUser.getApiKey();
        let token = GlobalUser.getToken();

        try {
            
            const apiFunctionParams =  "{\"id\": \""+id+"\"}";

            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({  apiFunctionName: "getCategoryOuterContactsByID",
                                        apiKey: apiKey,
                                        apiToken: token,
                                        apiFunctionParams: apiFunctionParams
                                    })
            };

            let url = SAJM_GLOBALS.API_HOST+"/";
            const response = await fetch(url, requestOptions);

                        
            if (!response.ok) {
                throw Error(response.statusText);
            }

            return await response.json();

        }
        catch (error) {
            console.log("SubscriptionController.getCategoryContacts:"+error);
        }
    }


    /**
     * Retrieve categories for a given contact id
     * @param {number} contactid contact id
     */
    async getCategoriesByContactId(contactid){
        let apiKey = GlobalUser.getApiKey();
        let token = GlobalUser.getToken();

        try {
            
            const apiFunctionParams =  "{\"contactid\": \""+contactid+"\"}";

            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({  apiFunctionName: "getCategoriesByContactId",
                                        apiKey: apiKey,
                                        apiToken: token,
                                        apiFunctionParams: apiFunctionParams
                                    })
            };

            let url = SAJM_GLOBALS.API_HOST+"/";
            const response = await fetch(url, requestOptions);

                        
            if (!response.ok) {
                throw Error(response.statusText);
            }

            return await response.json();

        }
        catch (error) {
            console.log("SubscriptionController.getCategoriesByContactId:"+error);
        }
    }   


    /*Retourne les contacts ids d'une category */
    async updateSubscriptionUsers(subscription_id, contact_ids_toremove, contact_ids_toadd) {

        let apiKey = GlobalUser.getApiKey();
        let token = GlobalUser.getToken();

        try {
            
            /*const apiFunctionParams =  "{\"subscription_id\": \""+subscription_id+"\"," +
                                        "\"contacts_ids_toremove\": \""+contact_ids_toremove+"\","+
                                        "\"contacts_ids_toadd\": \""+contact_ids_toadd+"\"}";*/


            const apiFunctionParams =  {
                        subscription_id: subscription_id,
                        contacts_ids_toremove: contact_ids_toremove,
                        contacts_ids_toadd: contact_ids_toadd
            };

            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({  apiFunctionName: "updateUsersSubscription",
                                        apiKey: apiKey,
                                        apiToken: token,
                                        apiFunctionParams: apiFunctionParams
                                    })
            };

            let url = SAJM_GLOBALS.API_HOST+"/";
            const response = await fetch(url, requestOptions);

                        
            if (!response.ok) {
                throw Error(response.statusText);
            }

            return await response.json();

        }
        catch (error) {
            console.log("SubscriptionController.updateSubscriptionUsers:"+error);
        }
    }

}